const Emoji: React.FC<{ className?: string }> = ({ className = '' }) => {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.2368 6.99025C13.3005 7.32064 13.3333 7.65859 13.3333 7.99992C13.3333 9.41441 12.7713 10.771 11.7712 11.7712C10.771 12.7713 9.41441 13.3333 7.99992 13.3333C6.58543 13.3333 5.22888 12.7713 4.22868 11.7712C3.22849 10.771 2.66659 9.41441 2.66659 7.99992C2.66659 6.58543 3.22849 5.22888 4.22868 4.22868C5.22888 3.22849 6.58543 2.66659 7.99992 2.66659C8.70189 2.66659 9.3896 2.80498 10.0266 3.06665C10.083 2.60962 10.2275 2.17988 10.4427 1.79496C9.68625 1.49695 8.86221 1.33325 7.99992 1.33325C4.31792 1.33325 1.33325 4.31792 1.33325 7.99992C1.33325 11.6819 4.31792 14.6666 7.99992 14.6666C11.6819 14.6666 14.6666 11.6819 14.6666 7.99992C14.6666 7.60252 14.6318 7.21325 14.5652 6.83497C14.2293 6.94215 13.8714 7 13.5 7C13.4115 7 13.3237 6.99671 13.2368 6.99025ZM5.99992 7.99992H4.66659C4.66659 8.88397 5.01777 9.73182 5.6429 10.3569C6.26802 10.9821 7.11586 11.3333 7.99992 11.3333C8.88397 11.3333 9.73182 10.9821 10.3569 10.3569C10.9821 9.73182 11.3333 8.88397 11.3333 7.99992H9.99992C9.99992 8.53035 9.78921 9.03906 9.41413 9.41413C9.03906 9.78921 8.53035 9.99992 7.99992 9.99992C7.46949 9.99992 6.96078 9.78921 6.5857 9.41413C6.21063 9.03906 5.99992 8.53035 5.99992 7.99992Z"
                fill="#646464"
            />
            <path
                d="M12.75 3.75V2.25H13.25V3.75H14.75V4.25H13.25V5.75H12.75V4.25H11.25V3.75H12.75Z"
                fill="#646464"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 2H13.5V3.5H15V4.5H13.5V6H12.5V4.5H11V3.5H12.5V2Z"
                fill="#646464"
            />
        </svg>
    );
};

export default Emoji;
